import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaAcuerdos(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [postNombre, setPostNombre] = useState("");
  const [postFecha, setPostFecha] = useState("");
  const [postAcuerdo, setPostAcuerdo] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = async (e) => {
    e.preventDefault();

    if (!postNombre || !postFecha || !postAcuerdo) {
      alert("Debe completar todos los campos");
      return;
    }

    setLoading(true);

    try {
      const response = await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaAcuerdosSindicales",
        data: {
          nombre: postNombre,
          fechaAcuerdo: postFecha,
          acuerdoEstablecido: postAcuerdo,
          SolicitudId: props.idSolicitud,
        },
      });

      // 🔹 ENVÍA EL NUEVO REGISTRO AL PADRE
      props.onAcuerdoCreado(response.data);

      alert("Acuerdo creado con éxito");
      setIsOpen(false);

      // limpiar campos
      setPostNombre("");
      setPostFecha("");
      setPostAcuerdo("");
    } catch (error) {
      console.error(error);
      alert("Error al crear acuerdo");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-primary mb-3" onClick={() => setIsOpen(true)}>
        Nuevo
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="card shadow">
          <div className="card-header">
            <h6 className="font-weight-bold text-primary">
              Crear Acuerdo Sindical
            </h6>
          </div>

          <div className="card-body">
            <form onSubmit={postData}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nombre del sindicato"
                  value={postNombre}
                  onChange={(e) => setPostNombre(e.target.value)}
                />
              </div>

              <div className="form-group">
                <label className="font-weight-bold text-primary">
                  Fecha del Acuerdo
                </label>
                <input
                  type="date"
                  className="form-control"
                  value={postFecha}
                  onChange={(e) => setPostFecha(e.target.value)}
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Acuerdos establecidos y costos"
                  value={postAcuerdo}
                  onChange={(e) => setPostAcuerdo(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={loading}
              >
                {loading ? "Guardando..." : "Guardar"}
              </button>
            </form>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaAcuerdos;
